module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "evaluation com-mar-btm"
  }, [_c('x-header', {
    staticClass: "header-define",
    attrs: {
      "title": _vm.title,
      "left-options": {
        showBack: false
      }
    }
  }, [_c('a', {
    attrs: {
      "slot": "left"
    },
    on: {
      "click": function($event) {
        _vm.$router.back()
      }
    },
    slot: "left"
  }, [_c('svg', {
    staticClass: "vux-x-icon vux-x-icon-ios-arrow-back",
    attrs: {
      "type": "ios-arrow-back",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "d": "M352 128.4L319.7 96 160 256l159.7 160 32.3-32.4L224.7 256z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "evaluation-main"
  }, [_c('div', {
    staticClass: "page-index"
  }, [_c('div', {
    staticClass: "result-item"
  }, [_c('p', {
    staticClass: "res-one"
  }, [_vm._v("\n          " + _vm._s(_vm.params.result) + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "res-two",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n          您本次风险测评问卷为C1\n        ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "8px",
      "background": "#F5F5F5",
      "margin": "0 -20px"
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('choose-button', [_c('template', {
    slot: "left"
  }, [_c('x-button', {
    nativeOn: {
      "click": function($event) {
        _vm.$_evaluation_confirm(0)
      }
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('template', {
    slot: "right"
  }, [_c('x-button', {
    nativeOn: {
      "click": function($event) {
        _vm.$_evaluation_confirm(1)
      }
    }
  }, [_vm._v("是")])], 1)], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "production-item"
  }, [_c('div', {
    staticStyle: {
      "font-size": "16px",
      "color": "#222222",
      "margin-bottom": "10px"
    }
  }, [_vm._v("需确认您是否为最低风险承受能力的投资者（符合下列条件之一）")]), _vm._v(" "), _c('div', [_vm._v("1、不具有完全民事行为能力；")]), _vm._v(" "), _c('div', [_vm._v("2、没有风险容忍度或者不愿承受任何投资损失；")]), _vm._v(" "), _c('div', [_vm._v("3、法律、行政法规规定的其他情形")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ef35a6d"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Evaluation/lastLow.vue
// module id = 1022
// module chunks = 1